import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { TextField, Button, Box, Typography } from '@mui/material';

const RP = () => {
  const { token } = useParams(); // Получаем токен из URL
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const navigate = useNavigate();

  // Обновление состояний для полей пароля
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'newPassword') setNewPassword(value);
    if (name === 'confirmPassword') setConfirmPassword(value);
  };

  // Обработка отправки формы
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setError('Пароли не совпадают.');
      return;
    }

    setLoading(true);
    setError('');
    setSuccessMessage('');

    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/api/auth/reset-password/${token}`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ newPassword }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Ошибка при сбросе пароля.');
      }

      setSuccessMessage('Пароль успешно обновлен. Перенаправление на главную страницу...');
      setTimeout(() => navigate('/'), 2000); // Перенаправление на главную страницу
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{
        maxWidth: 400,
        margin: '50px auto',
        padding: 3,
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
        borderRadius: 2,
        backgroundColor: '#fff',
        textAlign: 'center',
      }}
    >
      <Typography variant="h5" gutterBottom>
        Сброс пароля
      </Typography>
      {error && (
        <Typography color="error" variant="body2" gutterBottom>
          {error}
        </Typography>
      )}
      {successMessage && (
        <Typography color="primary" variant="body2" gutterBottom>
          {successMessage}
        </Typography>
      )}
      <TextField
        label="Новый пароль"
        name="newPassword"
        type="password"
        value={newPassword}
        onChange={handleChange}
        required
        fullWidth
        margin="normal"
      />
      <TextField
        label="Подтвердите пароль"
        name="confirmPassword"
        type="password"
        value={confirmPassword}
        onChange={handleChange}
        required
        fullWidth
        margin="normal"
      />
      <Button
        type="submit"
        variant="contained"
        color="primary"
        fullWidth
        disabled={loading}
        sx={{ mt: 2 }}
      >
        {loading ? 'Обновление...' : 'Сбросить пароль'}
      </Button>
    </Box>
  );
};

export default RP;
